import * as MA from 'ApplicationEntry/models/ModalApplication';
import {MAX_PRIMARY_BENEFICIARIES} from 'ApplicationEntry/models/PrimaryBeneficiaryList';
import React, {useState} from 'react';
import './PrimaryBeneficiary.sass';
import PrimaryBeneficiaryDialog from './PrimaryBeneficiaryDialog';
import PrimaryBeneficiaryTabularList from './PrimaryBeneficiaryTabularList';

import {Button, Divider, Typography} from '@material-ui/core';

import Alert from '@material-ui/lab/Alert';
import {ApplicationModeType} from 'ApplicationEntry/models/ApplicationModeType';

type PrimaryBeneficiaryProps = {
  modalApplication: MA.InvalidModalApplication | MA.ValidModalApplication;
};

export default function PrimaryBeneficiaryDashboard(props: PrimaryBeneficiaryProps) {
  const {application, mode} = props.modalApplication;

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getTotalPercent = () => {
    return application.primaryBeneficiaryList.primaryBeneficiaryList.reduce((a, b) => a + b.percent, 0);
  };

  const isQuality = mode === ApplicationModeType.Quality;

  return (
    <div className="primary-beneficiary-section">
      <div className="primary-beneficiary-section__main-header">
        <Typography variant="subtitle1" className="primary-beneficiary-section__head" color="primary">
          Primary Beneficiaries List
        </Typography>
        {application.primaryBeneficiaryList.primaryBeneficiaryList.size < MAX_PRIMARY_BENEFICIARIES ? (
          <Button
            variant="contained"
            color="primary"
            onClick={handleClickOpen}
            className="primaryBeneficiary-section__main-header-button"
            disabled={
              application.primaryBeneficiaryList.primaryBeneficiaryList.size >= MAX_PRIMARY_BENEFICIARIES
                ? true
                : false
            }
          >
            ADD PRIMARY BENEFICIARY
          </Button>
        ) : null}
      </div>
      {application.primaryBeneficiaryList.primaryBeneficiaryList.size < 1 ? (
        <>
          <div className="primary-beneficiary-section__no-item">
            <div className="primary-beneficiary-section__box">
              <div className="primary-beneficiary-section__image" />

              <h3 className="primary-beneficiary-section__title">No Associated Primary Beneficiary</h3>
              <Typography className="primary-beneficiary-section__content" variant="body2" color="initial">
                Click the "Add Primary Beneficiary" button above to add a beneficiary
              </Typography>
            </div>
          </div>
        </>
      ) : (
        <PrimaryBeneficiaryTabularList primaryBeneficiaryItem={application.primaryBeneficiaryList} mode={mode} />
      )}

      <PrimaryBeneficiaryDialog
        dialogOpen={open}
        dialogClose={handleClose}
        dialogTitle="Add Primary Beneficiary(s)"
        dialogSubTitle="Beneficiary(s) Information"
        dialogAdditional="ADDITIONAL BENEFICIARY"
        primaryBeneficiaryIndex={0}
        editPrimaryBeneficiary={false}
      />
      <div>
        {getTotalPercent() < 100 &&
        getTotalPercent() > 0 &&
        application.primaryBeneficiaryList.primaryBeneficiaryList.size > 0 ? (
          <Alert severity="warning">Sum of percent is not 100%.</Alert>
        ) : null}
      </div>
      <Divider className="application-form__actions-divider" />
    </div>
  );
}
